import { render, staticRenderFns } from "./BadgeInfoIcon.vue?vue&type=template&id=3330e855"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3330e855')) {
      api.createRecord('3330e855', component.options)
    } else {
      api.reload('3330e855', component.options)
    }
    module.hot.accept("./BadgeInfoIcon.vue?vue&type=template&id=3330e855", function () {
      api.rerender('3330e855', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/BadgeInfoIcon.vue"
export default component.exports